<template>
  <h2 id="testtesttest">Download - {{ $route.params.file_id }}</h2>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "RouteFile",
  sockets: {
    connect: async function () {},
  },
  async mounted() {
    console.log("==========");
    console.log(new Date());
    console.log("Поехали");
    console.log("==========");
    this.fetch_download_file({
      url: `${this.$w_api.DOWNLOAD_FILE}/${this.$route.params.file_id}`,
      body: {
        user_id: "60f5219099779d0015087a2e",
      },
    });
  },
  methods: {
    ...mapActions(["fetch_download_file"]),
  },
  computed: {
    ...mapGetters(["getUserData"]),
  },
};
</script>
